export default __webpack_public_path__ + "static/media/csc01.32b30ce1.jpg";